import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import About from '../components/About'
import Home from '../components/Home';
import Contact from '../components/Contact'
import Services from '../components/Services'
import Clients from '../components/Clients'
// import ContactListing from '../components/Dashboard/ContactListing'
import Privacy from '../components/Privacy'
import Plan from '../components/Plan'

const Layout = () => {
  return (
    <>
      <BrowserRouter>
      <Header/>
      <Routes>
        <Route path='/' element={<Home/>}>Home</Route>
        <Route path='/about' element={<About/>}>About</Route>
        <Route path='/contact' element={<Contact/>}>Contact</Route>
        <Route path='/services' element={<Services/>}>Contact</Route>
        <Route path='/client' element={<Clients/>}>Contact</Route>
        {/* <Route path='/listing' element={<ContactListing/>}>Contact</Route> */}
        <Route path='/privacy' element={<Privacy/>}>Privacy</Route>
        <Route path='/plans' element={<Plan/>}>Plans</Route>
      </Routes>
      <Footer/>
      </BrowserRouter>
    </>
  )
}

export default Layout